import { type Registry as Services, service } from '@ember/service';
import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TotalRevenueSegmentationBreakdownSummaryReference } from 'lumen/models';

export default class TotalRevenueSegmentationBreakdownSummaryItem extends Model {
  [Type] = 'total-revenue/segmentation-breakdown/summary-item' as const;

  @hasMany('total-revenue/segmentation-breakdown/summary-reference', {
    async: false,
    inverse: 'totalRevenueItem',
  })
  declare referenceValues: HasMany<TotalRevenueSegmentationBreakdownSummaryReference>;

  @attr('number') declare matchedNonRoomRevenue: number;
  @attr('number') declare unmatchedNonRoomRevenue: number;

  @service declare totalRevenue: Services['total-revenue'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedMatchedNonRoomRevenue() {
    return this.totalRevenue.formatValue(this.matchedNonRoomRevenue);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedUnmatchedNonRoomRevenue() {
    return this.totalRevenue.formatValue(this.unmatchedNonRoomRevenue);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get sortedReferenceValues() {
    return this.totalRevenue.sortReferenceValues([...this.referenceValues]);
  }
}
